//
const setMenuState = ($) => {
  const parts = location.pathname.substr(1).split('/')
  if (parts.length < 2) {
    return
  }

  const $mm = $('[data-nav="main_mobile"]')
  const aActive = $(`[href="${location.pathname}"]`, $mm)[0]
  if (aActive) {
    //prev
    $mm
      .find('.mm-opened')
      .removeClass('mm-opened')
      .removeClass('mm-current')
      .add('mm-hidden')

    // current
    const panel = $(aActive).closest('.mm-panel')
    panel
      .removeClass('mm-hidden')
      .addClass('mm-opened')
      .addClass('mm-current')

    // mm-subopened
    const up = (panel) => {
      const id = panel.attr('id')
      const partentChevron = $(`.mm-next[data-target="#${id}"]`, $mm)
      if (partentChevron.get(0)) {
        panel = partentChevron.closest('.mm-panel')
        panel.addClass('mm-subopened').addClass('mm-opened')
        up(panel)
      }
    }

    up(panel)
  }
}

export default setMenuState



// WEBPACK FOOTER //
// app/javascript/sg/js/mobile_menu_state.js